<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <language></language>
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">{{ $t('ResetPassword') }}</h4>
                                    <p>{{ $t('PleaseEnterYourNewPassword') }}</p>
                                </div>

                                <div class="mt-6">{{ $t('Email') }} *</div>
                                <vs-input
                                    v-validate="'required|email|min:3'"
                                    data-vv-validate-on="blur"
                                    name="email"
                                    v-model="email"
                                    @keyup.enter="reset"
                                    class="w-full mb-6"/>
                                <div class="text-danger text-sm mb-5">{{ errors.first('email') }}</div>

                                <div class="mt-6">{{ $t('password') }} *</div>
                                <vs-input type="password" v-model="password" @keyup.enter="reset" class="w-full" autocomplete="off" />

                                <div class="mt-6">{{ $t('ConfirmPassword') }} *</div>
                                <vs-input type="password" v-model="password_confirmation" @keyup.enter="reset" class="w-full mb-6" autocomplete="off" />

                                <div class="flex flex-wrap justify-between sm:flex-row">
                                    <vs-button class="w-full sm:w-auto" :disabled="!validateForm" @click="reset">{{ $t('ResetPassword') }}</vs-button>
                                    <vs-button type="border" to="/pages/login" class="w-full sm:w-auto sm:mb-auto mt-3 sm:mt-auto">{{ $t('BackToLogin') }}</vs-button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
    import Language from "../components/Language";

export default {
    components: {
        Language,
    },
    data() {
        return {
            token: '',
            email: '',
            password: '',
            password_confirmation: '',
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any() && this.email != '';
        },
    },
    created() {
        this.token = this.$route.query.token;
    },
    methods: {
        reset() {
            const thisIns = this;
            this.$vs.loading();

            axios.post(apiUrl+'/auth/reset', {token: this.token, email: this.email, password: this.password, password_confirmation: this.password_confirmation})
                .then(function (response) {

                    let data = response.data;
                    if(data.code === 200){
                        thisIns.$router.push('/pages/login');
                    }else{
                        if (data.code === 401){
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text:  data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                    thisIns.$vs.loading.close();
                });
        },
    }
}
</script>
